import { gql } from '@apollo/client';

export const APPLICATIONS_DATA = gql`
  query APPLICATIONS_DATA($userUuid: ID!) {
    getApplicationsByUserUuid(guildUuid: $userUuid) {
      id
      uuid
      state
      programUuid
      academicPartnerUuid
      userUuid
      responses {
        key
        value
      }
    }
  }
`;
